// Maps the tenant dual-write status to a tone-aware Pill.

import { Pill } from "../../components/ui/Pill";
import type { VaultSyncStatus } from "../../api/types/tenant";

const TONE = {
  synced: { tone: "ok", label: "Vault synced" },
  pending: { tone: "warn", label: "Vault pending" },
  error: { tone: "crit", label: "Vault error" },
} as const;

interface VaultSyncPillProps {
  status: VaultSyncStatus;
  title?: string;
}

export function VaultSyncPill({ status, title }: VaultSyncPillProps) {
  const t = TONE[status] ?? TONE.error;
  return (
    <Pill tone={t.tone} title={title}>
      {t.label}
    </Pill>
  );
}
